module.exports = __webpack_public_path__ + "img/s_preview_tt.264573f0.png";